import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueCookies from 'vue-cookies'
import elementEnUSLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhCNLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import enUSLocale from './en'
import zhCNLocale from './zh'

Vue.use(VueI18n)

const messages = {
  en_us: Object.assign(elementEnUSLocale, enUSLocale),
  zh_cn: Object.assign(elementZhCNLocale, zhCNLocale),
}


const i18n = new VueI18n({
  locale: VueCookies.get('language') || 'zh_cn',
  // locale: VueCookies.get('language') || 'en_us',
  messages
})


export default i18n



// WEBPACK FOOTER //
// ./src/assets/lang/index.js